module.exports = __webpack_public_path__ + "static/media/branding-img25.760afb75.jpg";